import { Component } from '@angular/core';

import { faCalendarDays } from '@fortawesome/pro-solid-svg-icons';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/** Shape returned to callers that opt into the date field via dateLabel. */
export interface ConfirmModalDateResult {
  confirmed: true;
  date: string | null;
}

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    standalone: false
})
export class ConfirmModalComponent {
  title?: string;
  content?: string;
  falseLabel?: string;
  trueLabel?: string;
  contentIsHtml = false;
  switchButtonColour = false;
  falseButtonClass?: string;
  trueButtonClass?: string;
  checkboxLabel?: string;
  checkboxChecked = false;

  // Optional date field, opted in by setting dateLabel — same convention as
  // checkboxLabel above. Bound as a YYYY-MM-DD string by the app's global
  // NgbDateYYYYMMDDAdapter.
  dateLabel?: string;
  dateValue?: string | null;
  dateHint?: string;
  dateMaxDate?: NgbDateStruct;

  faCalendar = faCalendarDays;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  get resolvedFalseButtonClass(): string {
    return this.falseButtonClass ?? 'btn-outline-dark';
  }

  get resolvedTrueButtonClass(): string {
    return this.trueButtonClass ?? (this.switchButtonColour ? 'btn-danger text-white' : 'btn-success text-white');
  }

  get trueButtonDisabled(): boolean {
    if (this.checkboxLabel && !this.checkboxChecked) {
      return true;
    }

    if (this.dateLabel && !this.dateValue) {
      return true;
    }

    return false;
  }

  responseFalse() {
    this.activeModal.close(false);
  }

  /**
   * Callers that didn't opt into the date field still get a plain `true`, so the
   * boolean contract every other consumer of this modal relies on is unchanged.
   */
  responseTrue() {
    if (this.dateLabel) {
      const result: ConfirmModalDateResult = { confirmed: true, date: this.dateValue ?? null };
      this.activeModal.close(result);
      return;
    }

    this.activeModal.close(true);
  }
}
